import { render, staticRenderFns } from "./CleanTemplate.vue?vue&type=template&id=920961c8&scoped=true&"
import script from "./CleanTemplate.vue?vue&type=script&lang=js&"
export * from "./CleanTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "920961c8",
  null
  
)

export default component.exports